import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '@/api'
import './Detail.css'

type Article = {
  id: number
  type: string
  name: string
  value: string // HTML 富文本
  estimated_read_time?: number
  created_at?: string
  updated_at?: string
}

const HtmlContent: React.FC<{ html: string }> = ({ html }) => {
  const sanitized = useMemo(() => html, [html])
  return <div className="article-content" dangerouslySetInnerHTML={{ __html: sanitized }} />
}

const Detail: React.FC = () => {
  const { type = '', id = '' } = useParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [article, setArticle] = useState<Article | null>(null)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    setError(null)
    const hasType = Boolean(type)
    if (!hasType) {
      setError('缺少必要参数')
      setLoading(false)
      return
    }

    api
      .getArticleDetail(type, id)
      .then((data: Article) => {
        if (!mounted) return
        setArticle(data)
      })
      .catch((err: unknown) => {
        if (!mounted) return
        setError((err as Error)?.message || '加载失败')
      })
      .finally(() => {
        if (!mounted) return
        setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [type, id])

  if (!type && !id) {
    return <div className="article-page"><div className="article-empty">缺少必要参数</div></div>
  }

  return (
    <div className="article-page">
      <header className="article-header">
        <h1 className="article-title">{article?.name || '加载中...'}</h1>
        {(article?.created_at || article?.estimated_read_time) ? (
          <div className="article-meta">
            {article?.created_at ? `发布于 ${article.created_at}` : ''}
            {article?.created_at && article?.estimated_read_time ? ' ｜ ' : ''}
            {article?.estimated_read_time ? `阅读时长 ${article.estimated_read_time} 分钟` : ''}
          </div>
        ) : null}
      </header>

      {loading && (
        <div className="article-loading">
          <div className="loading-spinner"></div>
          <div className="loading-text">正在加载...</div>
        </div>
      )}
      {error && <div className="article-error">{error}</div>}
      {!loading && !error && article && (
        <HtmlContent html={article.value || ''} />
      )}
    </div>
  )
}

export default Detail


